// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.databaseTab_wrapper__3zajf {
  padding: 25px 0 25px 0; }

.databaseTab_header__mllXM {
  display: flex;
  justify-content: space-between;
  color: var(--HightEmphasis);
  margin-bottom: 10px; }
  .databaseTab_header_title__DAVHs {
    font-weight: 600;
    font-size: 24px;
    line-height: 150%; }
  .databaseTab_header_buttons__jx107 {
    display: flex;
    gap: 58px; }

.databaseTab_desc__oK3\\+6 {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px; }
  .databaseTab_desc_title__c6CaY {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--MediumEmphasis); }

.databaseTab_container__v0kr1 {
  display: flex;
  flex-direction: column;
  gap: 10px; }
`, "",{"version":3,"sources":["webpack://./src/pages/configuration/components/DatabaseTab/databaseTab.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB,EAAA;EACnB;ICLA,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EDMjB;IACE,aAAa;IACb,SAAS,EAAA;;AAIb;ECgBE,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA;EDhBjB;ICcA,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDdf,4BAA4B,EAAA;;AAIhC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA","sourcesContent":["@import 'src/styles/media.scss';\n@import 'src/styles/fonts.scss';\n\n.wrapper {\n  padding: 25px 0 25px 0;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  color: var(--HightEmphasis);\n  margin-bottom: 10px;\n  &_title {\n    @include h2;\n  }\n  &_buttons {\n    display: flex;\n    gap: 58px;\n  }\n}\n\n.desc {\n  @include body1;\n  &_title {\n    @include body1;\n    color: var(--MediumEmphasis);\n  }\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `databaseTab_wrapper__3zajf`,
	"header": `databaseTab_header__mllXM`,
	"header_title": `databaseTab_header_title__DAVHs`,
	"header_buttons": `databaseTab_header_buttons__jx107`,
	"desc": `databaseTab_desc__oK3+6`,
	"desc_title": `databaseTab_desc_title__c6CaY`,
	"container": `databaseTab_container__v0kr1`
};
export default ___CSS_LOADER_EXPORT___;
